module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"free loan":"Free loanly","givent":"Given","mthly":"mthly"},"de":{"free loan":"Leihweise","givent":"Geschenkt","mthly":"mtl."}}')
  delete Component.options._Ctor
}
